import { useEffect, useState } from "react";
import { Input, Form, Button } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

import { Warning2 } from "iconsax-react";
import Swal from "sweetalert2";

import { ref, push as firebasePush, child, set } from "firebase/database";
import MobileLayout from "../../components/MobileLayout";
import { useProfiles } from "../../hooks/profile";
import { useAuth } from "../../hooks/auth";

import { database } from "../../config/firebase";

import { Main } from "./styles";

function VideoForm() {
  const { state } = useLocation();
  const { getAll } = useProfiles();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [link, setLink] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (user && user.type !== "admin" && !user.isAdmin) {
      navigate("/403");
      return;
    }

    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        console.error("Failed to load user profile:", error);
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, user]);

  async function addVideo(uid: string, title: string, link: string) {
    Swal.fire({
      title: "Cadastrando...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        const runAddVideo = async () => {
          Swal.showLoading();
          const videoRef = firebasePush(
            child(ref(database), `/modules/${state.id}/videos/`)
          );
          try {
            await set(videoRef, { title, link });
            Swal.close();
            Swal.fire({
              icon: "success",
              title: "Cadastro de Módulo",
              text: `Módulo cadastrado com sucesso!`,
              showConfirmButton: false,
              timer: 1800,
            }).then(() => navigate(-1));
          } catch (error) {
            console.error("Failed to add video:", error);
            Swal.fire({
              icon: "error",
              title: "Erro ao cadastrar",
              text: "Houve um problema ao salvar o vídeo. Tente novamente.",
            });
          }
        };
        runAddVideo();
      },
    });
  }

  return (
    <MobileLayout headerTitle="Novo Vídeo" headerType="private">
      <Main>
        <div className="box">
          <strong>
            <h1>Dados do Vídeo</h1>
          </strong>
          <Form onFinish={() => addVideo(state.id, title, link)}>
            <Form.Item
              label="Título do Vídeo"
              name="title"
              rules={[{ required: true, message: "O título é obrigatório" }]}
            >
              <Input
                id="title"
                name="title"
                placeholder="Insira o título do vídeo"
                value={title}
                onChange={(e: any) => setTitle(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              label="Link do Vídeo"
              style={{ marginTop: "20px" }}
              name="link"
              rules={[{ required: true, message: "O link é obrigatório" }]}
            >
              <Input
                id="link"
                name="link"
                value={link}
                onChange={(e: any) => setLink(e.target.value)}
                placeholder="Insira o link do vídeo"
              />
            </Form.Item>
            <footer>
              <p>
                <Warning2 size={48} />
                Atenção! <br />É necessário preecher todos os dados.
              </p>
              <Button htmlType="submit">Salvar cadastro</Button>
            </footer>
          </Form>
        </div>
      </Main>
    </MobileLayout>
  );
}

export default VideoForm;
